import React from "react";
import { GoHome, GoHomeFill } from "react-icons/go";
import { RiDashboardLine, RiDashboardFill } from "react-icons/ri";
import { RiMoonClearLine, RiMoonClearFill } from "react-icons/ri";

import NavIcons from "./NavIcons";

const NAV_ITEMS = [
  { href: "#home", icon: <GoHome />, hoverIcon: <GoHomeFill /> },
  {
    href: "#project",
    icon: <RiDashboardLine />,
    hoverIcon: <RiDashboardFill />,
  },
  {
    href: "",
    icon: <RiMoonClearLine />,
    hoverIcon: <RiMoonClearFill />,
  },
];

const Navbar = () => {
  return (
    <nav className="flex items-center justify-center w-full h-max">
      <div className="w-max p-3 flex gap-6 rounded-[25px] text-lg backdrop-blur-[10px] bg-darkTheme-bg-secondary">
      {NAV_ITEMS.map((item, index) => (
        <NavIcons
          key={index}
          href={item.href}
          icon={item.icon}
          hoverIcon={item.hoverIcon}
        />
      ))}
      </div>
    </nav>
  );
};

export default Navbar;
